<div class="holder">
  <h1>Kullanıcılar İçin?</h1>
  <div class="content">
    <div class="flowchart-container">
      <div class="flowchart-item">
        <div class="flowchart-item--img">
          <img src="/assets/images/old-flow-chart/1.svg" />
        </div>
        <h3 class="flowchart-item--title">Bilgesin'e Katıl</h3>
        <span class="flowchart-item--text">
          Üye olduktan sonra, sana özel ve en uygun anketler iletilecek.
        </span>
      </div>
      <div class="flowchart-arrow">
        <img src="/assets/images/old-flow-chart/right-arrow.svg" />
      </div>
      <div class="flowchart-item">
        <div class="flowchart-item--img">
          <img src="/assets/images/old-flow-chart/2.svg" />
        </div>
        <h3 class="flowchart-item--title">
          Anketi Yanıtlayarak İndirim/Hediye Kazan
        </h3>
        <span class="flowchart-item--text">
          Soruları içtenlikle yanıtlayın. Anket sonunda indirim/hediye kodunuzu
          alın.
        </span>
      </div>
      <div class="flowchart-arrow">
        <img src="/assets/images/old-flow-chart/right-arrow.svg" />
      </div>
      <div class="flowchart-item">
        <div class="flowchart-item--img">
          <img src="/assets/images/old-flow-chart/3.svg" />
        </div>
        <h3 class="flowchart-item--title">İndirim/Hediye Kodunu Kullan</h3>
        <span class="flowchart-item--text">
          İndirim/hediye kodunuzu, dilerseniz markanın websitesinde veya
          uygulamasında, dilerseniz de markanın mağazasında kullanarak kazanmaya
          başlayın.
        </span>
      </div>
    </div>

    <div class="text-holder">
      <b>Fikriniz Değerli, Kazancınız Gerçek </b>
      <br /><br />
      Günlük hayatta kullandığınız ürünler, takip ettiğiniz markalar ya da
      deneyimlediğiniz hizmetler hakkında zaman zaman fikir yürütüyorsunuz.
      <br />
      Peki bu görüşleriniz doğrudan markalara ulaşsa ve karşılığında size somut
      bir kazanç sağlasa?
      <br />
      Bilgesin ile bu artık mümkün!
      <br />
      <br />
      <b>Bilgesin Nedir?</b>
      <br /><br />
      Bilgesin, markalar ile tüketicileri bir araya getiren dijital bir
      araştırma platformudur.
      <br />
      Gerçek kullanıcı deneyimlerini merkeze alır; böylece markalar ürün ve
      hizmetlerini geliştirmek için doğrudan sizden geri bildirim alır.
      <br />
      Bu süreçte hem katkı sağlar hem de kazanç elde edersiniz.
      <br />
      <br />
      <b>Nasıl İşliyor?</b>
      <br /><br />
      <ul>
        <li>İlgilendiğiniz markaların anketlerini görüntülersiniz.</li>
        <li>Kısa ve kolay sorularla görüşlerinizi paylaşırsınız.</li>
        <li>
          Anketi tamamladığınızda, size özel bir indirim kodu veya hediye
          tanımlanır. Bu ödülü kampanya türüne göre markanın online ya da fiziki
          mağazasında kullanabilirsiniz.
        </li>
        <li>Katılım süreci basit, hızlı ve tamamen ücretsizdir.</li>
      </ul>
      <br /><br />
      <b>Neden Katılmalısınız? </b>
      <br /><br />
      <ul>
        <li>Fikirleriniz karşılıksız kalmaz.</li>
        <li>Anketler kısa ve kullanıcı dostudur.</li>
        <li>Katılım ücretsizdir, bilgileriniz gizli tutulur.</li>
        <li>
          Sadece bir tüketici değil, markaların gelişimine yön veren biri
          olursunuz.
        </li>
      </ul>
      <br /><br />
      <b>Güvenilir mi?</b>
      <br /><br />
      <ul>
        <li>
          Kesinlikle. Bilgesin yalnızca güvenilir ve sektöründe öncü markalarla
          çalışır.
        </li>
        <li>
          Kazanımlarınız, size özel kampanya kodları ile tarafınıza ulaşır.
          <br />
          Hesabınız üzerinden kazandığınız fırsatların tamamını
          görüntüleyebilirsiniz.
        </li>
        <li>
          Başlamak için hemen aşağıdaki bağlantıdan kayıt olabilirsiniz.
        </li>
      </ul>
      <br /><br />
      <a href="https://bilgesin.com/login"> https://bilgesin.com/login </a>
    </div>
  </div>

  <!-- <div class="video-container">
    <video
      [src]="videoSrc"
      [poster]="posterSrc"
      controls="true"
      preload="metadata"
      (play)="onChangeEvt('play')"
      (pause)="onChangeEvt('pause')"
      #videoPlayer
    ></video>
    <img
      class="play-btn"
      src="/assets/images/play-circle.svg"
      (click)="playVideoPlayer()"
      *ngIf="!playing"
    />
  </div> -->
</div>
